import Modal from './components/Modal.vue';

export { Modal };
